<template>
    <o-form-group
        :form-state="formState"
        :label="label"
        :message="errorMessages"
        :nolabel="nolabel"
        :type="{ 'is-danger': hasError }"
    >
        <b-form-tags
            :class="input_class"
            :disabled="_is_readonly"
            :value="value"
            @input="on_input"
            remove-on-delete
            separator=",;"
        ></b-form-tags>
    </o-form-group>
</template>

<script>
import FormComponentMixin from "../../../mixins/form_component_mixin";
import OFormGroup from "../OFormGroup";

export default {
    name: "OTagInput",
    components: { OFormGroup },
    mixins: [FormComponentMixin],
    data() {
        return {};
    },
    props: {},
    methods: {},
    computed: {},
};
</script>

<style scoped></style>
